/** @jsx jsx */
import { useContext, useState } from "react"
import { jsx, useThemeUI } from "theme-ui"
import { PropTypes } from "prop-types"

import ModeContext from "../context/mode-context"
import JsonLd from "./json-ld"
import buildFaqSchema from "../utils/faq-schema"

const Arrow = ({ isOpen, modeColor }) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="97.59 168.88 304.82 162.25"
        sx={{
            width: "1.5em",
            height: "1.5em",
            mt: "0.25em",
            transform: isOpen ? "rotate(0deg)" : "rotate(-180deg)",
            fill: modeColor,
                    }}>
        <path d="M97.59 178.71L250.01 331.13 402.41 178.71 392.58 168.88 250.01 311.47 107.42 168.88Z"/>
    </svg>
)

const FaqEntry = ({ entry, modeColor }) => {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <div
            sx={{
                py : 3,
                borderBottom: "1px solid",
                borderColor: "#ddd",
                "&:last-of-type": {
                    borderBottom: "none",
                },
            }}
        >
            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                sx={{
                    background : "none",
                    border: "none",
                    p: 0,
                    m: 0,
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "left",
                    gap: 3,
                    cursor: "pointer",
                    font: "inherit",
                    color: "inherit",
                }}
            >
                <Arrow isOpen={isOpen} modeColor="text" />
                <h3 sx={{ my: 1 }}>{entry.question}</h3>
            </button>
            {isOpen && (
                <div
                    sx={{
                    }}
                >
                    <p>{entry.answer}</p>
                </div>
            )}
        </div>
    )
}

const Faq = ({ headline, about, entries = [], mode}) => {
    const { mode: globalMode } = useContext(ModeContext)
    const { rawColors: colors } = useThemeUI().theme
    const modeKey = mode ? mode : globalMode
    const modeColor = colors.modes[modeKey]?.primary ?? colors.modes["group"].primary

    return (
        <section
            sx={{
                variant: "spacingContainer",
            }}
        >
        <JsonLd schema={buildFaqSchema(entries)} />
            {headline && <h2>{headline}</h2>}
            <div>
                {entries.map((entry, i) => (
                    <FaqEntry key={entry._uid} entry={entry} modeColor={modeColor} />
                ))}
            </div>
        </section>
    )
}

Faq.propTypes = {
    headline: PropTypes.string,
    about: PropTypes.string,
    entries: PropTypes.arrayOf(
        PropTypes.shape({
            question: PropTypes.string.isRequired,
            answer: PropTypes.string.isRequired,
        })
    ),
    mode: PropTypes.string, 
}

export default Faq